import { gql } from "@apollo/client";

export const GET_PROMOTIONS = gql`
  query Promotions($params: GetPromosInput) {
    promotions(params: $params) {
      items {
        promoEventId
        promoName
        retailerName
        purchaserName
        promoStartDate
        promoEndDate
        type {
          promoTypeId
          promoTypeName
          promoTypeCode
          promoTypeKey
        }
        status {
          promoStatusId
          promoStatusName
          promoStatusKey
        }
        financials {
          committedBudget
          previouslyClaimed
          remainingOpenBalance
        }
        matchCount
        isCurrentlyActive
      }
      total
      page
      limit
    }
  }
`;
